export const hasTouchSupport = Boolean(
    'ontouchstart' in window ||
    window.DocumentTouch && document instanceof window.DocumentTouch ||
    navigator.maxTouchPoints > 0 ||
    window.navigator.msMaxTouchPoints > 0
);

export const isMobile = (() => {
    const MobileDetectNode = document.getElementById('mobile-detect');
    const {zIndex} = window.getComputedStyle(MobileDetectNode);

    return +zIndex === 1;
})();
